<template>
    <v-dialog
    v-model="localValue"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Nov klient
      </v-card-title>

      <v-card-text>
        <CompanyClientForm
          ref="companyClientForm"
          :modalView="true"
          :countryList="countryList"
          @save="save"
          @cancel="cancel"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CompanyClientForm from './CompanyClientForm'

export default {
  components: {
    CompanyClientForm
  },
  props: {
    countryList: {
      required: true,
      type: Array
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },
  methods: {
    save (form) {
      this.$emit('confirmed', form)
    },
    cancel () {
      this.clearForm()
      this.$emit('input', false)
    },
    clearForm () {
      this.$refs.companyClientForm.clearForm()
    }
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
